import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const BriefIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('BriefIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.32 14.75H3.095a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h8.775c.745 0 1.35.604 1.35 1.35v.894m-3.216 2.263.47 1.27a4.25 4.25 0 0 0 2.513 2.513l1.27.47-1.27.47a4.25 4.25 0 0 0-2.513 2.513l-.47 1.27-.47-1.27A4.25 4.25 0 0 0 7.02 10.48l-1.27-.47 1.27-.47a4.25 4.25 0 0 0 2.513-2.513z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
BriefIcon.id = 'BriefIcon';
BriefIcon.displayName = 'BriefIcon';
export default BriefIcon;
